import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";

const DialogCannotBeDoneAction = ({
    show,
    toggleShow,
    resourceName,
    action
}) => {
    return (
        <DialogAlertAction
            width="600px"
            widthContent="90%"
            variant="secondary"
            show={show}
            toggleShow={toggleShow}
            title={`No se puede ${action} el recurso ${resourceName}`}
            contentComponent={
                <p className="paragraph">
                    Recuerda que para {action} un recurso, no debe existir una reserva asignada.
                </p>}>
            <CustomButton
                size="medium"
                text="Cerrar"
                width="120px"
                onClick={() => toggleShow(false)}/>
        </DialogAlertAction>
    );
}

export default DialogCannotBeDoneAction;